import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import PageLoader from 'components/PageLoader';

import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import { getStudentLoanData } from 'selectors/getStudentLoanData';
import { getStudentLoanAssistanceData, getApplicationData as getApplicationDataThunk } from 'thunks';
import { getApplicationData } from 'selectors/getApplicationData';

type StudentLoanLoaderWrapperProps = {
  children?: JSX.Element;
};

const StudentLoanLoaderWrapper = ({ children }: StudentLoanLoaderWrapperProps) => {
  const dispatchWithUnwrap = useDispatchWithUnwrap();
  const studentLoanData = useSelector(getStudentLoanData);
  const { application, isLoading: isLoadingApplication } = useSelector(getApplicationData);
  const { applicationId, isLoading, fetched, refetch } = studentLoanData;

  useEffect(() => {
    if ((isLoading || !fetched) && applicationId) {
      dispatchWithUnwrap(getStudentLoanAssistanceData({ applicationId }));
    }

    // If there is a student loan application, fetch the application data
    if (applicationId && !application && !isLoadingApplication) {
      dispatchWithUnwrap(getApplicationDataThunk(applicationId));
    }
  }, [applicationId]);

  if ((isLoading || !fetched) && !refetch) {
    return <PageLoader />;
  }
  return <>{children}</>;
};

export default StudentLoanLoaderWrapper;
